export default "__VITE_ASSET__DzAY$Wnd__"